export * from '@shared/types';


// WEBPACK FOOTER //
// ./source/js/types/index.ts